<template>
	<div class="modal-wrap">
        <div class="modal-content">
			<img src="@/assets/images/order-manage/ic_order_off.png" class="close-icon" @click="onCloseClick">
			 <div class="modal">
				<div class="title">拒绝驳回原因</div>
				<ul class="list-wrap che-dan">
					<li>
						<textarea class="textarea" :rows="8" v-model="reason" @blur="backHeight" placeholder="请详细描述撤单原因，便于管理员找商家谈条件，好提高成功率"/>
					</li>
					
					<li class="admin-img">
						<div class="num">上传图片（{{addImages.length }}/6）</div>
						<imageUpload v-model="addImages" :limit="6" class="add-img"/>
					</li>
				</ul>
				<div class="modal-submit" @click="submitRefusal">提交</div>
			</div>
        </div>
	</div>
</template>

<script>
	import imageUpload from './ImageUpload';
    export default {
        data(){
            return{
				addImages:[],
				reason:''
            }
        },
        methods:{
            onCloseClick() {
                this.reason = "";
                this.addImages = [];
                this.$emit('close-modal');
            },
            
            submitRefusal(){
				if(!this.reason){
					window,toast("请填写驳回原因","txt");
					return
				}
				
				if(this.reason.length>100){
					window,toast("驳回原因不得超过100字符","txt");
					return
				}
                this.$emit('submit-refusal',this.reason,this.addImages);
            },
            
            backHeight(){
                setTimeout(() => {
                    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                }, 100);
            }
        },
		components:{
			imageUpload
		}
        
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#FFF}
	.close-icon {.w(12);.h(12); position: relative;.t(-105);.t(15);right: -7.64rem;top: 0.9rem;}
	.modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
	.title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}

    .modal-wrap {position: fixed;width: 100vw;height: 100vh;top:0;left:0;background:rgba(0,0,0,0.6);display: flex;justify-content: center;align-items: center; z-index: 12;}
    .list-wrap{padding: 18px 21px 6px 21px;}
    .list-wrap li{margin-bottom: 10px}
    .show-wrap{.w(207.5);.h(200);margin: 0 auto;background:#FFF;.p-t(43);}
    .show-logo{.w(70);.h(70);margin: 0 auto;background: url(../assets/images/order-manage/pic_recharge_right2.png) center center no-repeat;background-size: cover}
    .show-text{.w(115);margin: 0 auto;.f-s(14);.m-t(18);font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);text-align: center}
	textarea{width: 278px;height: 105px;padding: 10px;background:rgba(245,245,245,1);border-radius:2px;border:1px solid rgba(207,207,207,1);resize: none;outline: none;font-size:13px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(153,153,153,1);}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.num{font-size:14px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);margin-bottom: 12px}
	.modal-submit{
	.w(277.5);.h(40);.l-h(40); margin: 0 auto;background: rgba(65,132,244,1);border-radius: 2px;.f-s(18);font-family: PingFangSC-Regular;
		font-weight: 400;color: rgba(255,255,255,1);text-align: center
	}
</style>
